<div class="cardsContainer">
    <div class="cardsColumn">
        <lib-generic-card
            [title]="'Main Info'"
            [highlight]="true"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.AccountMainInfo]"
            #mainInfoCard
            [hasArchivedItems]="hasArchivedUsers"
        >
        </lib-generic-card>
        <lib-generic-card
            [title]="'Additional Info'"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.AccountAdditionalInfo]"
            [hasArchivedItems]="hasArchivedProductType"
        ></lib-generic-card>
    </div>
    @if (cardsConfig[entityCardSection.AccountCustomInfo] && cardsConfig[entityCardSection.AccountCustomInfo].length) {
        <div class="cardsColumn">
            <lib-generic-card
                [title]="'Custom Info'"
                [factory]="factory"
                [configItems]="cardsConfig[entityCardSection.AccountCustomInfo]"
                #customInfoCard
            >
            </lib-generic-card>
        </div>
    }
</div>
